import { FilterValues, ReportFilter } from '../types/filters';

export const updateQueriesWithFilters = <
  T extends {
    baseQuery: string;
    display?: { visualization?: { queries?: { baseQuery: string }[]; type: string } };
  },
>(
  items: T[],
  filters: ReportFilter[],
  filterValues: FilterValues,
) => {
  return (
    items?.map((item) => {
      const newItem = { ...item };
      if (item.display?.visualization?.queries) {
        newItem.display!.visualization!.queries = updateQueriesWithFilters(
          item.display.visualization.queries,
          filters,
          filterValues,
        );
      }

      let baseQueryModified = item.baseQuery;
      for (const filter of filters) {
        const { filterExpression } = filter;
        const filterValue = filterValues[filter.filterLabel as keyof FilterValues];
        if (filterValue && filterExpression) {
          baseQueryModified = baseQueryModified?.replaceAll(filterExpression, filterValue);
        } else {
          // remove expressions from query if no filter value
          // things like "AND filterExpression", "or filterExpression", etc
          const regex = new RegExp(
            `(?:(?:AND|OR|and|or)\\s+)?${filterExpression?.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`)}`,
            'g',
          );
          baseQueryModified = baseQueryModified?.replaceAll(regex, '');
        }
      }

      newItem.baseQuery = baseQueryModified.trim();

      return newItem;
    }) ?? []
  );
};
